import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MobileMenu extends Component {

    state = {
        active: false
    }

    toggleMobileMenu = () => {
        this.setState({
            active: !this.state.active
        })
    }

    componentDidMount() {
        var offCanvasNav = document.getElementById('offcanvas-navigation');
        var offCanvasNavSubMenu = offCanvasNav.querySelectorAll('.sub-menu');

        for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
            offCanvasNavSubMenu[i].insertAdjacentHTML("beforebegin", "<span class='menu-expand'><i></i></span>");
        }

        var menuExpand = offCanvasNav.querySelectorAll('.menu-expand');
        var numMenuExpand = menuExpand.length;

        function sideMenuExpand() {

            if (this.parentElement.classList.contains('active') === true) {
                this.parentElement.classList.remove('active');
            } else {
                for (let i = 0; i < numMenuExpand; i++) {
                    menuExpand[i].parentElement.classList.remove('active');
                }
                this.parentElement.classList.add('active');
            }
        }

        for (let i = 0; i < numMenuExpand; i++) {
            menuExpand[i].addEventListener("click", sideMenuExpand);
        }
    }


    render() {
        return (
            <div>
                {/*=======  offcanvas mobile menu  =======*/}
                <div className={`offcanvas-mobile-menu ${this.state.active ? 'active' : ''} `} id="mobile-menu-overlay">
                    <a href="#/" className="offcanvas-menu-close" id="mobile-menu-close-trigger" onClick={this.toggleMobileMenu}>
                        <i className="ion-android-close" />
                    </a>
                    <div className="offcanvas-wrapper">
                        <div className="offcanvas-inner-content">
                            <div className="offcanvas-mobile-search-area">
                                <form action="#">
                                    <input type="search" placeholder="Search ..." />
                                    <button type="submit"><i className="fa fa-search" /></button>
                                </form>
                            </div>
                            <nav className="offcanvas-navigation" id="offcanvas-navigation">
                                <ul>
                                    <li><Link to="/">HOME</Link></li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/about-us`}>ABOUT</Link></li>
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/services`}>SERVICES</Link>
                                        <ul className="sub-menu">
                                            <li><Link to={`${process.env.PUBLIC_URL}/early-intervention`}>Early Intervention & Child Development</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/play-language-therapy`}>Play & Language Therapy</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/social-communication`}>Social Communication & Behaviour Modification</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/speech-therapy`}>Speech Therapy</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/special-education`}>Special Education</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/learning-support`}>Learning Support</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/occupational-therapy`}>Occupational Therapy</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/parent-counselling`}>Parent Counselling & Guidance</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/holistic-child-development`}>Holistic Child Development</Link></li>
                                            <li><Link to={`${process.env.PUBLIC_URL}/sports-program-development`}>Sports Programs for Development</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to={`${process.env.PUBLIC_URL}/contact-us`}>CONTACT</Link> </li>
                                </ul>
                            </nav>
                            <div className="offcanvas-widget-area">
                                <div className="off-canvas-contact-widget">
                                    <div className="header-contact-info">
                                        <ul className="header-contact-info__list">
                                            <li><i className="ion-android-phone-portrait" /> <a href="tel:+919643532525">+91 96435 32525</a></li>
                                            <li><i className="ion-android-mail" /> <a href="mailto:info@shakuntlafoundation.org">info@shakuntlafoundation.org</a></li>
                                        </ul>
                                    </div>
                                </div>
                                {/*Off Canvas Widget Social Start*/}
                                <div className="off-canvas-widget-social">
                                    <a href="https://www.facebook.com/people/Shakuntla-Learn-and-Fly-Foundation/61573371158620/"><i className="zmdi zmdi-facebook" /></a>
                                    <a href="https://x.com/shakuntlaf48371"><i className="zmdi zmdi-twitter" /></a>
                                    <a href="https://www.linkedin.com/company/shakuntla-learn-and-fly-foundation/"><i className="zmdi zmdi-linkedin-box" /></a>
                                    <a href="https://www.instagram.com/shakuntla_foundation_/"><i className="zmdi zmdi-instagram" /></a>
                                    <a href="https://www.threads.com/@shakuntla_foundation_"><i className="zmdi zmdi-share" /></a>
                                </div>
                                {/*Off Canvas Widget Social End*/}
                            </div>
                        </div>
                    </div>
                </div>
                {/*=======  End of offcanvas mobile menu  =======*/}

            </div>
        )
    }
}

export default MobileMenu;